export const CS = {
  "Open document": "OtevÅÃ­t dokument",
  "Upload file": "NahrÃ¡t soubor",
  "Drop file here to upload": "PÅetÃ¡hnÄte soubor sem a nahrajte jej",
  "Disc": "Disk",
  "URL": "URL",
  "FILE": "SOUBOR",
  "SIZE": "VELIKOST",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Bajty",
  "Loading... Please wait.": "NaÄÃ­tÃ¡nÃ­ prosÃ­m Äekejte.",
  "Fit Width": "PÅizpÅ¯sobit Å¡Ã­Åce",
  "Fit Height": "PÅizpÅ¯sobit vÃ½Å¡ce",
  "Password protected document": "Dokument chrÃ¡nÄnÃ½ heslem",
  "Password": "Heslo",
  "Open": "OtevÅeno",
  "Password Required": "VyÅ¾adovÃ¡no heslo",
  "Incorrect password": "NesprÃ¡vnÃ© heslo",
  "Error": "Chyba",
  "Something went wrong": "NÄco se pokazilo",
  "Server is not available": "Server nenÃ­ k dispozici",
  "of": "z",
  "Please wait...": "ProsÃ­m, Äekejte..."
};
